/**
 * @fileoverview gRPC-Web generated client stub for management
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: contract_historical.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.management = require('./contract_historical_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.management.ContractHistoricalClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.management.ContractHistoricalPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.management.EntityContractsRequest,
 *   !proto.management.EntityContractsResponse>}
 */
const methodDescriptor_ContractHistorical_GetContractsForEntity = new grpc.web.MethodDescriptor(
  '/management.ContractHistorical/GetContractsForEntity',
  grpc.web.MethodType.UNARY,
  proto.management.EntityContractsRequest,
  proto.management.EntityContractsResponse,
  /**
   * @param {!proto.management.EntityContractsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.management.EntityContractsResponse.deserializeBinary
);


/**
 * @param {!proto.management.EntityContractsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.management.EntityContractsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.management.EntityContractsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.management.ContractHistoricalClient.prototype.getContractsForEntity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/management.ContractHistorical/GetContractsForEntity',
      request,
      metadata || {},
      methodDescriptor_ContractHistorical_GetContractsForEntity,
      callback);
};


/**
 * @param {!proto.management.EntityContractsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.management.EntityContractsResponse>}
 *     Promise that resolves to the response
 */
proto.management.ContractHistoricalPromiseClient.prototype.getContractsForEntity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/management.ContractHistorical/GetContractsForEntity',
      request,
      metadata || {},
      methodDescriptor_ContractHistorical_GetContractsForEntity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.management.GetEntitiesRequest,
 *   !proto.management.GetEntitiesResponse>}
 */
const methodDescriptor_ContractHistorical_GetEntities = new grpc.web.MethodDescriptor(
  '/management.ContractHistorical/GetEntities',
  grpc.web.MethodType.UNARY,
  proto.management.GetEntitiesRequest,
  proto.management.GetEntitiesResponse,
  /**
   * @param {!proto.management.GetEntitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.management.GetEntitiesResponse.deserializeBinary
);


/**
 * @param {!proto.management.GetEntitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.management.GetEntitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.management.GetEntitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.management.ContractHistoricalClient.prototype.getEntities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/management.ContractHistorical/GetEntities',
      request,
      metadata || {},
      methodDescriptor_ContractHistorical_GetEntities,
      callback);
};


/**
 * @param {!proto.management.GetEntitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.management.GetEntitiesResponse>}
 *     Promise that resolves to the response
 */
proto.management.ContractHistoricalPromiseClient.prototype.getEntities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/management.ContractHistorical/GetEntities',
      request,
      metadata || {},
      methodDescriptor_ContractHistorical_GetEntities);
};


module.exports = proto.management;

